<app-template-number
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [max]="max"
  [required]="required"
  [commas]="commas"
  [decimalSeperator]="decimalSeperator"
  [label]="label"
/>
